<template>
  <div style="padding: 10px; width: 100%">
    <div
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
      "
    >
      {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
    </div>
    <div>
      <b>{{ $t("WorkRegistrationForm.PauseTitle") }}</b>
    </div>
    <div v-if="!addTimeManually">
      <div class="row">
        <div
        class="col-6"
        >
          <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
          <br />
          <label
            ><b>{{
              this.selectedStartTime
                ? moment(selectedStartTime).format("HH:mm")
                : " --:-- "
            }}</b></label
          >
        </div>
        <div
        class="col-6"
        >
          <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
          <br />
          <label
            ><b>{{
              this.selectedEndTime
                ? moment(selectedEndTime).format("HH:mm")
                : " --:-- "
            }}</b></label
          >
        </div>
      </div>
      <div class="row">
        <div
          class="col-6"
          style="padding: 10px"
        >
          <div class="div-field">
            <button
              :disabled="selectedStartTime"
              class="custom-mobile-button"
              @click="startActivity()"
            >
              {{ $t("WorkRegistrationForm.Start") }}
            </button>
          </div>
        </div>
        <div
          class="col-6"
          style="padding: 10px"
        >
          <div class="div-field">
            <button
              :disabled="selectedEndTime"
              class="custom-mobile-button"
              @click="stopActivity()"
            >
              {{ $t("WorkRegistrationForm.Stop") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div
        class="col-6"
        >
          <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
          <div class="div-field">
            <datetime
              v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
              v-model="selectedStartTime"
              v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
              input-style="text-align:center"
              class="theme-blue"
              v-bind:backdrop-click="false"
              :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
              :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
              input-id="inputStartTime"
              @input="onSelectStartTime"
            >
            </datetime>
          </div>
        </div>
        <div class="col-6">
          <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
          <div class="div-field">
            <datetime
              v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
              v-model="selectedEndTime"
              v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
              input-style="text-align:center"
              class="theme-blue"
              v-bind:backdrop-click="false"
              :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
              :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
            >
            </datetime>
          </div>
        </div>
      </div>
    </div>

    <div>
      <button
        v-if="!addTimeManually"
        class="custom-mobile-button"
        @click="enterTimeManually()"
      >
        {{ $t("WorkRegistrationForm.EnterTimeManually") }}
      </button>
      <button class="custom-mobile-button" @click="checkForPauseD()">
        {{ $t("WorkRegistrationForm.Save") }}
      </button>
      <BackButton />

    </div>
    <Confirmation
      @confirmed="onConfirmPauseD"
      :question='$t("WorkRegistrationForm.PauseDQuestion")'
      :display="showPauseDModal"
      :showNoButton="true"
    />
  </div>
</template>
<script>
import LocalStorageService from "../services/LocalStorageService";
import ProjectService from "../services/ProjectService";
import ActivityService from "../services/ActivityService";
import WorkRegistrationService from "../services/WorkRegistrationService";
import { formatDateTimeServer, formatDateServer, formatDateIsoTimeZone } from "../utils";
import BackButton from "../components/common/BackButton";
import moment from "moment";
import WorkSlipService from "../services/WorkSlipService";
import WorkDayService from "../services/WorkDayService";
import Confirmation from "../components/common/Confirmation";

export default {
  name: "AddPause",
  components: {
    BackButton,
    Confirmation
  },
  props: {
    drivers: null,
    workRegistration: null,
    workDate: null,
    workDayEndTime: null,
  },
  workRegistrationService: null,
  activityService: null,
  projectService: null,
  localStorageService: null,
  workSlipService: null,
  workDayService: null,
  data() {
    return {
      showDriverModal: false,
      projects: null,
      selectedProject: null,
      activities: null,
      selectedActivity: null,
      remark: "",
      selectedTime: null,
      selectedRemarks: [],
      remarks: null,
      maxDatetime: null,
      minDatetime: null,
      workDayId: null,
      isWorkSlipEmployee: false,
      employee: null,
      workSlip: null,
      workSlips: null,
      maxWrEndTime: null,
      selectedWorkSlip: null,
      selectedStartTime: null,
      selectedEndTime: null,
      filteredActivities: null,
      showEndTimeDialog: false,
      workDay: null,
      addTimeManually: false,
      moment: moment,
      saveDay: false,
      canClaimPauseD: false,
      showPauseDModal: false,
      workRegistrations: [],
      allSubTasks: [],
      contractPauzeDHours: null
    };
  },
  created() {
    this.workRegistrationService = new WorkRegistrationService();
    this.activityService = new ActivityService();
    this.projectService = new ProjectService();
    this.localStorageService = new LocalStorageService();
    this.workSlipService = new WorkSlipService();
    this.workDayService = new WorkDayService();
    this.employee = this.localStorageService.getCurrentEmployee();
    this.isWorkSlipEmployee = this.employee.isWorkSlipEmployee;
    this.workDayId = this.$route.query.workDayId;
    this.getProjectInfos();
    this.getActivityInfos();
    this.workDate = this.$route.query.workDate;
    this.getWorkSlipOptions();
    this.selectedActivity = this.activities;
    this.workRegistration = this.$route.query.workRegistration;
    this.addTimeManually = this.$route.query.addTimeManually
      ? this.$route.query.addTimeManually
      : false;
    if (this.workRegistration) {
      this.selectedStartTime = this.workRegistration.startTime;
      this.selectedEndTime = this.workRegistration.endTime;
    }
  },
  mounted() {
    this.minDatetime = this.workDate;
    this.maxDatetime = moment(this.workDate)
      .add(1, "days")
      .add(23, "hours")
      .add(59, "minutes")
      .format("YYYY-MM-DD[T]HH:mm:00");
    this.getWorkDay();
    // this.selectedStartTime = this.workDay.workRegistrations;
  },
  methods: {
    getWorkSlipOptions() {
      this.workSlipService
        .getWorkSlipOptions(this.workDate)
        .then((response) => {
          const result = response.data;
          if (result) {
            this.workSlips = result;
            this.workSlips.forEach((workSlip) => {
              if (
                this.workDay.workRegistrations.find((wr) => {
                  return (
                    wr.activityTypeId == workSlip.activityId &&
                    wr.workSlipNumber == workSlip.workSlipNumber
                  );
                })
              ) {
                workSlip.alreadyAdded = true;
              } else {
                workSlip.alreadyAdded = false;
              }
            });
          }
        })
        .catch(() => {});
    },
    onSelectedDriver(value) {
      this.showDriverModal = false;
      if (value && value.value === true) {
        const description = `Bestuurder: ${value.driver}`;
        this.remark = description;
      }
    },
    getWorkRegistrationMaxEndTime() {
      this.workRegistrationService
        .getWorkRegistrationMaxEndTime(this.workDayId, this.employee.id)
        .then((response) => {
          let self = this;
          self.maxWrEndTime = response.data;
          if (this.workRegistration) {
            this.selectedStartTime = formatDateTimeServer(
              new Date(this.workRegistration.startTime)
            );
            if (this.workRegistration.endTime != null) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workRegistration.endTime)
              );
            } else if(this.addTimeManually) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workDayEndTime)
              );
            }
          } else if(this.addTimeManually){
            const hours = new Date().getHours();
            const minutes = new Date().getMinutes();
            const startTime = new Date(this.workDate);
            startTime.setHours(hours);
            startTime.setMinutes(minutes);
            const dummyDate = new Date();
            if (self.maxWrEndTime) {
              this.selectedStartTime = formatDateTimeServer(self.maxWrEndTime);
              //var proposedEnd = new Date(self.maxWrEndTime);
              //proposedEnd.setHours(proposedEnd.getHours() + 1);
              //this.selectedEndTime = formatDateTimeServer(proposedEnd);
            } else {
              if(dummyDate.getDate() == startTime.getDate()) {
                this.selectedStartTime = formatDateTimeServer(startTime);
              }
              //var proposedEnd = new Date(startTime);
              //proposedEnd.setHours(proposedEnd.getHours() + 1);
              //this.selectedEndTime = formatDateTimeServer(proposedEnd);
            }
            if(this.isEnabledMidnightOption() && !this.selectedStartTime){
              this.hideStartTime();
            }
          }
        })
        .catch(() => {});
    },
    // eslint-disable-next-line no-dupe-keys, vue/no-dupe-keys
    getWorkSlipOptions() {
      this.workSlipService.getWorkSlipOptions(this.workDate)
        .then((response) => {
          const result = response.data;
          if (result) {
            this.workSlips = result;
            if (this.workRegistration) {
              this.selectedWorkSlip = this.workSlips.find(
                (s) => s.value === this.workRegistration.workSlipNumber
              );
            }
          }
        })
        .catch(() => {});
    },
    getProjectInfos() {
      this.projectService
        .getProjectInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.projects = result.map((s) => {
              return {
                id: s.id,
                name: `${s.projectNumber} ${s.name}`,
                isRecent: s.isRecent,
              };
            });
            if (this.workRegistration) {
              this.selectedProject = this.projects.find(
                (s) => s.id === this.workRegistration.projectId
              );
            }
            if (this.isWorkSlipEmployee) this.getWorkSlipOptions();
          }
        })
        .catch(() => {});
    },
    onSelectProject() {
      this.selectedObject = null;
    },
    getActivityInfos() {
      this.loader = this.$loading.show({});
      this.activityService
        .getActivityInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.activities = result.map((s) => {
              return {
                id: s.id,
                name: s.name,
                descriptionRequired: s.descriptionRequired,
                remarks: s.remarks,
                defaultProjectId: s.defaultProjectId,
                isRecent: s.isRecent,
                activityCode: s.activityCode,
              };
            });
            if (this.workRegistration) {
              this.selectedActivity = this.activities.find(
                (s) => s.id === this.workRegistration.activityId
              );
              this.remarks = this.selectedActivity.remarks;
              if (this.workRegistration) {
                this.remark = this.workRegistration.activityRemark || "";
                if (this.remark && this.remarks) {
                  this.remarks.forEach((s) => {
                    if (this.remark.indexOf(s.name) > -1) {
                      this.selectedRemarks.push(s);
                    }
                  });
                }
                this.getContractFormat(true);
              }
            }
            else{
              this.selectedActivity = this.activities.find((item) => {
            return item.activityCode == "130.000.00.001";
          });
          this.getContractFormat(false);
            }
          }
          this.filteredActivities = this.activities.filter((activity) => {
            return activity.activityCode[0] != "1";
          });
          this.loader.hide();
        })
        .catch(() => {this.loader.hide();});
    },
    onSelectActivity() {
      if (this.selectedActivity.defaultProjectId) {
        this.selectedProject = this.projects.find(
          (s) => s.id === this.selectedActivity.defaultProjectId
        );
      }
      this.remarks = this.selectedActivity.remarks;
      if (this.workRegistration) {
        this.remark = this.workRegistration.activityRemark || "";
        if (this.remark && this.remarks) {
          this.remarks.forEach((s) => {
            if (this.remark.indexOf(s.name) > -1) {
              this.selectedRemarks.push(s);
            }
          });
        }
      }
    },
    isEnabledMidnightOption() {
      let isMidnight = this.$route.query.isMidnight === true || false;
      if (isMidnight === true) return isMidnight;
      return (
        this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
        false
      );
    },
    checkIfWorkDayExists() {
      if (
        !this.selectedStartTime ||
        (this.addTimeManually && document.getElementById("inputStartTime").style[0] == "text-indent")
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
        return;
      }
      if (this.workDayId == 0) {
        this.workDayService.createWorkDay(this.workDate).then((response) => {
          const workDay = response.data;
          this.workDayId = workDay.id;
          this.workRegistrationService
            .getEmployeeFunctionTimeRegime(workDay.workDate)
            .then((response) => {
              this.defaultWorkDaySchedule = response.data;
              if (this.selectedStartTime) {
                if (
                  this.compareTimeSpanWithDates(
                    this.selectedStartTime,
                    response.data.defaultStartWork
                  ) == 1
                ) {
                  //this.showUnscheduledModal = true;
                  this.checkEmployeeType();
                } else {
                  this.checkEmployeeType();
                }
              }
            });
        });
      } else {
        this.workRegistrationService
          .getEmployeeFunctionTimeRegime(this.workDate)
          .then((response) => {
            this.defaultWorkDaySchedule = response.data;
            if (this.selectedStartTime) {
              if (
                this.compareTimeSpanWithDates(
                  this.selectedStartTime,
                  response.data.defaultStartWork
                ) == 1
              ) {
                //this.showUnscheduledModal = true;
                this.checkEmployeeType();
              } else {
                this.checkEmployeeType();
              }
            }
          });
      }
    },
    compareTimeSpanWithDates(date, timespan) {
      let splittedTimeSpan = timespan.split(":");
      let timeSpanHours = Number(splittedTimeSpan[0]);
      let timeSpanMinutes = Number(splittedTimeSpan[1]);
      let dateHours = Number(new Date(date).getHours());
      let dateMinutes = Number(new Date(date).getHours());
      if (timeSpanHours == dateHours) {
        if (timeSpanMinutes == dateMinutes) return 0;
        else if (timeSpanMinutes >= dateMinutes) return 1;
        else if (timeSpanMinutes <= dateMinutes) return -1;
      } else if (timeSpanHours >= dateHours) return 1;
      else if (timeSpanHours <= dateHours) return -1;
    },
    checkEmployeeType() {
      if (this.isWorkSlipEmployee) {
        this.saveWorkRegistration();
      } else {
        for (const wr of this.workDay.workRegistrations) {
          if (
            new Date(this.selectedStartTime).getTime() >=
              new Date(wr.startTime).getTime() &&
            new Date(this.selectedStartTime).getTime() <
              new Date(wr.endTime).getTime()
          ) {
            this.showEndTimeDialog = true;
            //return;
          }
        }
        this.saveWorkRegistration();
      }
    },
    saveWorkRegistration() {
      let startTime = formatDateTimeServer(new Date(this.selectedStartTime));
        // ? formatDateTimeServer(new Date(this.selectedStartTime))
        // : null;
        if(!this.isEnabledMidnightOption()){
          let dummyStartTime = new Date(this.workDay.workDate);
          dummyStartTime.setHours(new Date(this.selectedStartTime).getHours());
          dummyStartTime.setMinutes(new Date(this.selectedStartTime).getMinutes());
          startTime = formatDateTimeServer(new Date(dummyStartTime));
        }
      

      let dummyEndTime = new Date(this.workDay.workDate);
      let endTime = this.selectedEndTime;
      if(this.selectedEndTime && this.selectedEndTime != '' && this.selectedEndTime != 'Invalid date' && !this.isEnabledMidnightOption()){
        dummyEndTime.setHours(new Date(this.selectedEndTime).getHours());
        dummyEndTime.setMinutes(new Date(this.selectedEndTime).getMinutes());
        endTime = formatDateTimeServer(new Date(dummyEndTime));
      } else if(this.selectedEndTime == '' || this.selectedEndTime == 'Invalid date' || !this.selectedEndTime) {
          endTime = null;
        } else {
          endTime = formatDateTimeServer(new Date(this.selectedEndTime));
        }
      if(!this.selectedStartTime){
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
      if (!this.workRegistrationService.validateTimes(formatDateTimeServer(startTime), formatDateTimeServer(endTime))){
        return;
        }
      /*       let endTime = this.isWorkSlipEmployee
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : this.showEndTimeDialog
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : null; */
      this.showEndTimeDialog = false;
            if(!endTime && this.workDay && this.workDay.workRegistrations && this.workDay.workRegistrations.length > 1){
        var lastWrStartTime = new Date(this.workDay.workRegistrations[this.workDay.workRegistrations.length - 1].startTime).getTime();
        var lastWrEndTime = new Date(this.workDay.workRegistrations[this.workDay.workRegistrations.length - 1].endTime).getTime();
        var firstWrStartTime = new Date(this.workDay.workRegistrations[0].startTime).getTime();
        var currentStartTime = new Date(startTime).getTime();
        if(lastWrEndTime){
          if(currentStartTime < lastWrEndTime && currentStartTime > firstWrStartTime){
            this.$toast.add({
            severity: "warn",
            detail: "Please select an endtime if you want to add a work registration between another work registrations.",
            life: 5000,
            closable: false,
            });
            return;
          }
        }
        else{
          if(currentStartTime < lastWrStartTime && currentStartTime > firstWrStartTime){
            this.$toast.add({
            severity: "warn",
            detail: "Please select an endtime if you want to add a work registration between another work registrations.",
            life: 5000,
            closable: false,
            });
            return;
          }
        }
      }
      //if (this.workRegistrationService.validateTimes(startTime, endTime)) {
      let remark = `${this.remark.trim()} ${this.selectedRemarks
        .map((s) => s.name)
        .join(" | ")}`;
      const model = {
        projectId: this.selectedProject ? this.selectedProject.id : null,
        activityId: this.selectedActivity.id,
        startTime: startTime,
        endTime: endTime,
        activityRemark: remark,
        isWorkSlipEmployee: this.isWorkSlipEmployee,
        deviceId: this.localStorageService.getDeviceId(),
        workDayId: +this.workDayId,
        workSlipNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.workSlipNumber
          : null,
        orderNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.orderNumber
          : null,
      };
      
      this.loader = this.$loading.show({});
      if (this.workRegistration) {
        model.id = +this.workRegistration.id;
        model.workDayId = this.workRegistration.workDayId;
        this.workRegistrationService
          .updateWorkRegistration(model)
          .then(() => {
            this.loader.hide();
            //if (this.saveDay)
            return this.$router.push({
              name: "work-day",
              query: { workDate: formatDateServer(this.workDate) },
            });
          })
          .catch(() => {
            this.loader.hide();
          });
      } else {
        this.workRegistrationService
          .createWorkRegistration(model)
          .then((response) => {
            this.loader.hide();
            this.workRegistration = response.data;
            //if (this.saveDay)
            return this.$router.push({
              name: "work-day",
              query: { workDate: formatDateServer(this.workDate) },
            });
          })
          .catch(() => {
            this.loader.hide();
          });
      }
      //}
    },
    onSelectWorkSlip() {
      this.remark = "";
      if (!this.selectedWorkSlip) {
        this.filteredActivities = this.activities.filter((activity) => {
          return activity.activityCode[0] != "1";
        });
        this.selectedProject = null;
        return;
      }
      this.selectedProject = this.projects.find(
        (s) => s.id === this.selectedWorkSlip.projectId
      );
      this.selectedActivity = this.activities.find(
        (s) => s.id === this.selectedWorkSlip.activityId
      );
      //this.remark = this.selectedWorkSlip.workType;
      this.filteredActivities = this.activities.filter((activity) => {
        return activity.activityCode[0] == "1";
      });
    },
    getWorkDay() {
      const workDate = formatDateServer(this.workDate);
      if (
        new Date(workDate).getTime() !=
        new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      ) {
        this.addTimeManually = true;
      }
      this.workDayService.getWorkDay(workDate).then((res) => {
        this.workDay = res.data;
        this.getWorkRegistrationMaxEndTime();
        this.workRegistrations = res.data.workRegistrations;
        const subtasks = [];
        this.workRegistrations.forEach((wr) => {
          if(wr.subTasks.length > 0) {
            subtasks.push(wr.subTasks);
          }
        });
        this.allSubTasks = subtasks.flatMap(list => list);
      });
    },
    onSelectedEndTime(event) {
      //this.showEndTimeDialog = false;
      this.selectedEndTime = event.value;
      this.saveWorkRegistration();
    },
    startActivity() {
      this.selectedStartTime = this.getWorkDayWithCurrentTime();
      this.selectedStartTime = moment(this.selectedStartTime).toISOString();
      this.selectedStartTime = formatDateTimeServer(this.selectedStartTime);
      this.checkForPauseD();
    },
    stopActivity() {
      let currentDate = this.getWorkDayWithCurrentTime();
      if (
        new Date(currentDate).getTime() <=
          new Date(this.selectedStartTime).getTime() &&
        this.selectedStartTime
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "End time must be greater than start time",
          life: 3000,
          closable: false,
        });
      } else {
        this.selectedEndTime = currentDate;
        this.selectedEndTime = moment(this.selectedEndTime).toISOString();
        this.selectedEndTime = formatDateTimeServer(this.selectedEndTime);
        this.checkForPauseD();
      }
    },
    enterTimeManually() {
      this.addTimeManually = !this.addTimeManually;
      this.getWorkRegistrationMaxEndTime();
    },
    getWorkDayWithCurrentTime() {
      let workDate = new Date(this.workDate);
      workDate.setHours(new Date().getHours());
      workDate.setMinutes(new Date().getMinutes());
      return workDate;
    },
    checkTimes() {
      this.saveDay = true;
      if (
        this.workRegistrationService.validateTimes(
          formatDateTimeServer(this.selectedStartTime),
          formatDateTimeServer(this.selectedEndTime)
        ) &&
        this.selectedStartTime
      ) {
        this.checkIfWorkDayExists();
      } else {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
    },
    onSelectStartTime() {
      if (document.getElementById("inputStartTime") && document.getElementById("inputStartTime").style[0] == "text-indent")
        document.getElementById("inputStartTime").style = "text-align: center;";
    },
    hideStartTime() {
      if (document.getElementById("inputStartTime") == null) {
         setTimeout(() => this.hideStartTime(), 1000);
      } else {
        this.selectedStartTime = this.minDatetime;
        document.getElementById("inputStartTime").style = "text-indent: -99em;";
      }
    },
    getContractFormat(alreadyClaimedPauseD){
      if(alreadyClaimedPauseD){
        this.canClaimPauseD = false;
        return;
      }
      this.workDayService.getEmployeeContractFormat().then(response => {
        this.canClaimPauseD = response.data.breakDClaim;
        this.contractPauzeDHours = response.data.breakDHours;

      })
    },
    onConfirmPauseD(value){
      this.showPauseDModal = false;
      if(value){
        this.selectedActivity = this.activities.find((item) => {
            return item.activityCode == `110.${this.employee.functionId}.02.003` || item.activityCode == `110.${this.employee.functionId}.02.004` || item.activityCode == `113.000.00.001`;
          });
      }
      this.checkIfWorkDayExists();
    },
    checkForPauseD(){
      if (this.canClaimPauseD) {
        let breakTypeDDuration = 0;
        // const pWorkRegistrations = [];

        // this.workSlips.forEach((ws) => {
        //   const pWrs = this.workRegistrations.filter((wr) => {
        //     return (
        //       wr.activityTypeId == ws.activityId &&
        //       wr.workSlipNumber == ws.workSlipNumber
        //     );
        //   });
        //   if(pWrs) {
        //     pWorkRegistrations.push(pWrs);
        //   }
        // });
        // const plannedWorkRegistrations = pWorkRegistrations.flatMap(list => list);
        // console.log("Planned and registered workregistrations: ", plannedWorkRegistrations);
        // const subtasks = [];
        // plannedWorkRegistrations.forEach((wr) => {
        //   if(wr.subTasks.length > 0) {
        //     subtasks.push(wr.subTasks);
        //   }
        // });
        // const allPlannedSubTasks = subtasks.flatMap(list => list);
        // console.log("All planned and registered subtasks: ", allPlannedSubTasks);
        // allPlannedSubTasks.forEach((subtask) => {
        //   if(subtask.breakType == "113.000.00.001")
        //   {
        //     if(subtask.duration != 0) {
        //       breakTypeDDuration += subtask.duration;
        //     } else {
        //       const workReg = this.workRegistrations.find((wr) => {
        //         return wr.id == subtask.workRegistrationId;
        //       })
        //       breakTypeDDuration += Math.abs(new Date(workReg.endTime).getTime() - new Date(workReg.startTime).getTime());
        //     }
        //   }
        // })

        this.workSlips.forEach((ws) => {
          if (ws.subTaskBreakType == "113.000.00.001") {
            var workDateTime = formatDateIsoTimeZone(new Date(this.workDay.workDate)); 
            var workDateDate = workDateTime.split('T')[0];
            var startTime = new Date(workDateDate + 'T' + ws.workStart);
            var endTime = new Date(workDateDate + 'T' + ws.workEnd);

            console.log(startTime);
            console.log(endTime);

            breakTypeDDuration += Math.abs(new Date(endTime).getTime() - new Date(startTime).getTime());            
          }
        })
        console.log("BreakTypeDDuration (based on planned and registered workregistrations): ", breakTypeDDuration);

        // let pauzeDDuration = 0;
        // if(this.workRegistrations != null && this.workRegistrations.length > 0)
        // {
        //   this.workRegistrations.forEach((wr) => {
        //     if(wr.activityCode == `110.${this.employee.functionId}.02.003` || wr.activityCode == `110.${this.employee.functionId}.02.004` || wr.activityCode == '113.000.00.001')
        //     {
        //         pauzeDDuration += Math.abs(new Date(wr.endTime).getTime() - new Date(wr.startTime).getTime());
        //     }
        //   })
        // }
        // console.log("Pauze D (based on workregistrations and wr activitycode (not used)): ", pauzeDDuration);
        // const dummyEndTime = formatDateTimeServer(this.selectedEndTime);
        // let endTime = new Date(this.workDay.workDate);
        // endTime.setHours(new Date(dummyEndTime).getHours());
        // endTime.setMinutes(new Date(dummyEndTime).getMinutes());
        // endTime = formatDateTimeServer(new Date(endTime));
        // pauzeDDuration += Math.abs(new Date(endTime).getTime() - new Date(this.selectedStartTime).getTime());
        // console.log("Pauze D (incl. selected duration (not used)): ", pauzeDDuration);

        if(breakTypeDDuration >= (3 * 3600 * 1000)) //more than or equal to 3 hours
        {
          this.showPauseDModal = true
        } else {
          this.checkIfWorkDayExists()
        }       
      } else {
        this.checkIfWorkDayExists()
      }
    }
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
</style>
